import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import test from '../../images/re1.jpg'
import test1 from '../../images/re2.jpg'
import test2 from '../../images/re3.jpg'
import test3 from '../../images/re4.jpg'
import test4 from '../../images/re1.jpg'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import './Swiper.css';

// import required modules
import { Autoplay, EffectCoverflow, Navigation, Pagination } from 'swiper/modules';

// const TripSwiper = () => {
//   const trips = [
//     { id: 1, image: test  },
//     { id: 2, image: test1 },
//     { id: 3, image: test3 },
//     { id: 4, image: test4 },
//     { id: 5, image: test2 },
//     { id: 6, image: test2 },
//     { id: 7, image: test2 },
//     { id: 8, image: test2 },
//     { id: 9, image: test2 },
//     // أضف المزيد من الرحلات هنا
//   ];

//   return (
//     <Swiper
//       modules={[Navigation, Pagination, Autoplay]}
//       spaceBetween={50}
//       slidesPerView={1}
//       navigation
//       pagination={{ clickable: true }}
//       autoplay={{ delay: 3000 }}
//       loop
//     >
//       {trips.map((trip) => (
//         <SwiperSlide key={trip.id}>
//           <img className='review' src={trip.image} alt='img' />
//         </SwiperSlide>
//       ))}
//     </Swiper>
//   );
// };

// export default TripSwiper;



export default function App() {
  return (
    <>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={test}  className="review" alt=''/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test1} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test2} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test3} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test4} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test2} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test3} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test2} alt='' className="review"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={test1} alt='' className="review"/>
        </SwiperSlide>
      </Swiper>
    </>
  );
}